import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tendon',
  templateUrl: './tendon.component.html',
  styleUrls: ['./tendon.component.scss']
})
export class TendonComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnBackClick = function () {
    this.router.navigateByUrl('/conditions')
  }
}
